import { motion } from 'motion/react';
import { useGetParams } from '../../hooks/useGetParams';
import styles from './AdvtFullSize.module.css';

import { WordAnimated } from './WordAnimated';

import advtVideo from '../../assets/video/advtVideo.webm';

export const AdvtFullSize = () => {
  const { title } = useGetParams();

  return (
    <div className={styles.questionBlock}>
      <video autoPlay="autoplay" muted="muted" playsInline id="bgVideo">
        <source src={advtVideo} type="video/webm" />
      </video>

      {/* <motion.div
        className={styles.twoStr}
        initial={{ y: '5rem' }}
        animate={{ y: ['5rem', '-5rem', '0'] }}
        transition={{
          y: {
            duration: 0.8,
            delay: 1.4,
            times: [0, 0.4, 1],
          },
        }}
      >
        {titleArr[0] && (
          <motion.div
            style={{ width: 'max-content' }}
            initial={{ scale: 1.4, y: '4rem', transformOrigin: 'left' }}
            animate={{
              scale: 1,
              transformOrigin: 'left',
              y: ['4rem', '-4rem', '0'],
            }}
            transition={{
              scale: {
                duration: 0.4,
                delay: 0.2,
              },
              y: {
                duration: 0.8,
                delay: 0.6,
                times: [0, 0.4, 1],
                ease: ['easeOut', 'easeOut'],
              },
            }}
            className={styles.firstLine}
          >
            <WordAnimated word={titleArr[0]} allDuration={0.4} allDelay={0} />
          </motion.div>
        )}

        {titleArr[1] && (
          <motion.div
            initial={{ scale: 1.4, transformOrigin: 'left' }}
            animate={{ scale: 1, transformOrigin: 'left' }}
            transition={{
              duration: 0.4,
              delay: 0.2 + 0.8,
              ease: 'easeOut',
            }}
            className={styles.secondLine}
          >
            <WordAnimated word={titleArr[1]} allDuration={0.4} allDelay={0.6} />
          </motion.div>
        )}
      </motion.div>

      {titleArr[2] && (
        <motion.div
          initial={{ scale: 1.4, transformOrigin: 'left' }}
          animate={{ scale: 1, transformOrigin: 'left' }}
          transition={{
            duration: 0.4,
            delay: 0.2 + 1.6,
            ease: 'easeOut',
          }}
          className={styles.thirdLine}
        >
          <WordAnimated word={titleArr[2]} allDuration={0.4} allDelay={1.4} />
        </motion.div>
      )}

      {titleArr[3] && (
        <motion.div
          initial={{ y: '25vh', opacity: 0 }}
          animate={{
            y: '0',
            opacity: 1,
            transition: {
              opacity: { duration: 0.8, delay: 1.5 },
              y: { duration: 0.8, ease: 'easeOut', delay: 1.5 },
            },
          }}
          className={styles.fourthLine}
        >
          <div>{titleArr[3]}</div>
        </motion.div>
      )} */}
    </div>
  );
};
